import { Col, Row } from 'antd';
import { format } from 'date-fns';

import { convertESTToLocalTime } from '../../../../../../../../utilz/dates';
import EmptyRecords from '../../../../../../../components/Common/EmptyRecords';
import CommonModal from '../../../../../../../components/Modals/CommonModal';
import Paper from '../../../../../../../components/Paper/Paper';
import ContentSpinner from '../../../../../../../components/Spinners/ContentSpinner';
import TMSFiledCard from '../../../../../../common/components/TMSFiledCard';
import { useOCClaimEmailNotifications } from '../../../../hooks/use-oc-claim-email-notifications';

const OverChargeClaimEmailDetailsModal = ({ open, setOpen, fbocKey }) => {
  const { data: claimEmails = [], isPending } = useOCClaimEmailNotifications({ fbocKey, open });

  return (
    <CommonModal
      title="Email Tracking Details"
      open={open}
      onClose={() => setOpen(false)}
      destroyOnHidden
      // biome-ignore lint/complexity/noUselessFragments: not useless, it is placeholder
      customFooter={<></>}
      descriptionClassName="d-flex h-100"
      className="vw-90"
    >
      <div className="flex-1 custom-scroll-bar">
        {isPending ? (
          <ContentSpinner size="large" />
        ) : claimEmails?.length > 0 ? (
          claimEmails.map((row, key) => (
            // biome-ignore lint/suspicious/noArrayIndexKey: static
            <EmailCard key={key} data={row} />
          ))
        ) : (
          <EmptyRecords title="There is no email records found!" descriptionOne="" descriptionTwo="" />
        )}
      </div>
    </CommonModal>
  );
};

export default OverChargeClaimEmailDetailsModal;

const EmailCard = ({ data }) => {
  return (
    <Paper className="mb-15 p-10" border>
      <Row gutter={10}>
        <Col sm={2}>
          <TMSFiledCard title="Claim Key">{data.claimKey}</TMSFiledCard>
        </Col>
        <Col sm={4}>
          <TMSFiledCard title="Senders Email">{data.sendersEmail}</TMSFiledCard>
        </Col>
        <Col sm={4}>
          <TMSFiledCard title="Recipient">{data.recipient}</TMSFiledCard>
        </Col>
        <Col sm={3}>
          <TMSFiledCard title="Sent On">
            {data.sentOn ? format(convertESTToLocalTime(data.sentOn), 'MM/dd/yyyy HH:mm:ss a') : ''}
          </TMSFiledCard>
        </Col>
        <Col sm={4}>
          <TMSFiledCard title="Email Subject">{data.emailSubject}</TMSFiledCard>
        </Col>
        <Col sm={2}>
          <TMSFiledCard title="Status Desc">{data.statusDesc}</TMSFiledCard>
        </Col>
        <Col sm={2}>
          <TMSFiledCard title="Description">{data.description}</TMSFiledCard>
        </Col>
        <Col sm={3}>
          <TMSFiledCard title="Date Time Of Action">
            {data.dateTimeOfAction ? format(convertESTToLocalTime(data.dateTimeOfAction), 'MM/dd/yyyy HH:mm:ss a') : ''}
          </TMSFiledCard>
        </Col>
      </Row>
    </Paper>
  );
};
